/**
 * Copyright (C), 2012-2018, Sichuan Xiaoka Technology Co., Ltd.
 * */
import axios from 'axios'
import api from '../api'
import Vue from 'vue'
import QS from 'qs'
import JSONBig from 'json-bigint-xk'

Vue.prototype.$axios = {
  get: api.getAxios,
  put: api.putAxios,
  post: api.postAxios,
  delete: api.deleteAxios
}
axios.defaults.timeout = 30000 // 30秒超时

axios.defaults.transformResponse = [function (data) {
  try {
    console.log("大id转换：", JSONBig.parse(data));
    return JSONBig.parse(data)
  } catch (err) {
    return data
  }
}]

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      pending[p].f() // 执行取消操作
      pending.splice(p, 1) // 把这条记录从数组中移除
    }
  }
}

// Add a request interceptor 请求
axios.interceptors.request.use(function (config) {
  // console.log(config.url)
  // console.log(config.params, config.data)
  // -----取消重复请求--start-----
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    pending.push({u: config.url + '&' + config.method, f: c})
  })
  // -----取消重复请求--end-----
  // -----post/put请求--start-----
  let cookieAppKey = Vue.prototype.$Cookie.get('cookieAppKey') ? Vue.prototype.$Cookie.get('cookieAppKey') : null
  if (config.method === 'post' || config.method === 'put') {
    if (config.url === '/upImg') {
      config.headers['Content-Type'] = 'application/json'
    } else {
      config.data = {
        ...config.data,
        app_key: cookieAppKey,
        timestamp: Date.parse(new Date()) / 1000,
        // terminal: 'wechat_boss'
      }
      config.data = QS.stringify(config.data)
    }
  } else {
    config.params = {
      ...config.params,
      app_key: cookieAppKey,
      timestamp: Date.parse(new Date()) / 1000,
      // terminal: 'wechat_boss'
    }
  }
  // -----post/put请求--end-----

  return config
}, function (error) {
  return Promise.reject(error)
})

// Add a response interceptor 响应
axios.interceptors.response.use(function (response) {
  return response.data
}, function (error) {
  console.log('response响应error:', JSON.stringify(JSON.parse(error)))
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/axios/index.js